export const GRID_OPACITY = 0.5
export const GRID_DISCARD_THRESHOLD = 0.1
export const GRID_GRID_COLOR_RGB = [0.8, 0.8, 0.8] as [number, number, number]
export const GRID_LINE_WIDTH = 0.5

export const GRID_VERTEX_SHADER = `
  varying vec2 vUv;
  void main() {
    vUv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  }
`

export const GRID_FRAGMENT_SHADER = `
  uniform float gridSize;
  uniform float canvasSize;
  uniform vec3 gridColor;
  uniform float lineWidth;
  uniform float gridOpacity;
  varying vec2 vUv;
  
  void main() {
    vec2 grid = abs(fract(vUv * canvasSize / gridSize) - 0.5) / fwidth(vUv * canvasSize / gridSize);
    float line = min(grid.x, grid.y);
    float alpha = 1.0 - min(line, 1.0);
    
    if (alpha < ${GRID_DISCARD_THRESHOLD}) discard;
    
    gl_FragColor = vec4(gridColor, alpha * gridOpacity);
  }
`
